// @flow
import { call, put, select, takeEvery } from 'redux-saga/effects';
import type { PhoneLinesActionType } from './actions';
import { fetchPhoneLinesSuccess, resetPhoneLines, setPhoneLines } from './actions';
import { tripica } from '../../api';
import HandleErrorService from '../../lib/handleError';
import { phoneLinesSelector } from '../Subscriptions';
import { phoneLinesEditingDataSelector } from './selectors';
import { deviceIdSelector } from '../Authentication/selectors';
import WizzeeLog from '../../lib/wizzeeLog';

export function* resetPhoneLinesSaga(action: PhoneLinesActionType): Generator<*, *, *> {
  try {
    const currentPhoneLines = yield select(phoneLinesSelector);
    yield put(fetchPhoneLinesSuccess(currentPhoneLines));
  } catch (error) {
    WizzeeLog.warn('[saga] resetPhoneLinesSaga', error);
  }
}

export function* updatePhoneLinesSaga(action: PhoneLinesActionType): Generator<*, *, *> {
  try {
    const updatedPhoneLines = yield select(phoneLinesEditingDataSelector);
    const deviceId = yield select(deviceIdSelector);
    yield call([tripica, 'changePhoneLinesPreferences'], updatedPhoneLines, deviceId);
    yield put(setPhoneLines(updatedPhoneLines));
  } catch (error) {
    WizzeeLog.warn('[saga] updatePhoneLinesSaga', error);
    yield put(resetPhoneLines());
    yield call(HandleErrorService.showToastError, error);
  }
}

export default function* phoneLinesSaga(): Generator<*, *, *> {
  yield takeEvery('RESET_PHONE_LINES', resetPhoneLinesSaga);
  yield takeEvery('UPDATE_PHONE_LINES', updatePhoneLinesSaga);
}
